<div class="saturation-value" [style.height.px]="height" [style.width.px]="width">
  <div
    #container
    class="saturation-value-gradient"
    tabindex="0"
    [class.use-gradient]="useCSSGradient"
    [style.background-color]="fullColorHue"
    (mousedown)="setColor($event)"
  >
    <div class="clip-region">
      <canvas #gradient [height]="height" [width]="width"></canvas>
      <div
        #cursor
        class="cursor"
        [style.top.px]="valuePos"
        [style.left.px]="satPos"
        (mousedown)="onCursorMouseDown($event)"
      ></div>
    </div>
  </div>
</div>
